import _ from "lodash";
import { FieldProps } from "@/core/components/Field";
import { AutosuggestInputSource } from "../../../../core/components/Autosuggest/Autosuggest";
import { AirportsAutosuggest } from "./AirportsAutosuggest";
import { AirlinesAutosuggest } from "./AirlinesAutosuggest";
import { AddressesAutosuggest } from "@/MIE/components/custom/AddressAutosuggest/AddressAutosuggest";

export const AutosuggestWrapper = ({ field, ...props }: FieldProps) => {
  const { source } = field.properties;

  if (source === AutosuggestInputSource.AIRPORTS)
    return <AirportsAutosuggest field={field} {...props} />;
  if (source === AutosuggestInputSource.AIRLINES)
    return <AirlinesAutosuggest field={field} {...props} />;
  if (source === AutosuggestInputSource.ADDRESSES)
    return <AddressesAutosuggest field={field} {...props} />;

  return null;
};

export default AutosuggestWrapper;
